export const TOKEN_LOCALSTORAGE_KEY = "token";
export const USER_LOCALSTORAGE_KEY = "user";
